import { useContext } from "react";

import { BoardStatisticsContext } from "./BoardStatisticsContext";

export const useBoardStatistics = () => useContext(BoardStatisticsContext);
